import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import ChecklistPicker from '../picker/ChecklistPicker'

const ChecklistsFilter = ({ field, ...props }) => {
  const { t } = useTranslation('checklists')
  field = field || 'checklistIds'
  const label = t('checklist')
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()

  return (
    <div>
      <ChecklistPicker value={value} onChange={handleChange(field)} multiple label={label} {...props} />
    </div>
  )
}

export default ChecklistsFilter
